// Shows the ingredients of each product inside a Shopify Bundles bundle in the product page's
// Ingredients block. Liquid can't see bundle components, so they come from the Storefront API
// (tokenless, which allows components but not metafields) and each component's image comes
// from the product.bundle-ingredients alternate template.
(function () {
	const API_URL = "/api/2025-07/graphql.json";
	const QUERY = `query BundleComponents($id: ID!) {
		node(id: $id) {
			... on ProductVariant {
				requiresComponents
				components(first: 30) {
					nodes {
						productVariant {
							id
							product { handle }
						}
					}
				}
			}
		}
	}`;

	const latestRequest = {};

	const fetchComponents = async (variantId) => {
		const response = await fetch(API_URL, {
			method: "POST",
			headers: { "Content-Type": "application/json" },
			body: JSON.stringify({
				query: QUERY,
				variables: { id: `gid://shopify/ProductVariant/${variantId}` },
			}),
		});
		if (!response.ok) return [];

		const json = await response.json();
		const variant = json && json.data && json.data.node;
		if (!variant || !variant.requiresComponents) return [];

		return variant.components.nodes.map((component) => component.productVariant);
	};

	const fetchIngredientsHtml = async (componentVariant) => {
		const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/";
		const variantId = componentVariant.id.split("/").pop();
		const url = `${root}products/${componentVariant.product.handle}?variant=${variantId}&view=bundle-ingredients`;

		const response = await fetch(url);
		if (!response.ok) return "";
		return (await response.text()).trim();
	};

	const load = async (sectionId, variantId) => {
		const block = document.getElementById(`NutritionBlock-${sectionId}`);
		const wrapper = document.getElementById(`NutritionImageWrapper-${sectionId}`);
		if (!block || !wrapper || !variantId) return;

		latestRequest[sectionId] = String(variantId);

		try {
			const components = await fetchComponents(variantId);
			if (!components.length) return;

			const parts = await Promise.all(components.map(fetchIngredientsHtml));
			const html = parts.filter((part) => part !== "").join("");

			if (latestRequest[sectionId] !== String(variantId) || html === "") return;

			wrapper.innerHTML = `<div class="bundle-ingredients">${html}</div>`;
			wrapper.style.display = "block";
			block.style.display = "";
		} catch (error) {
			console.error("Bundle ingredients failed to load", error);
		}
	};

	window.BundleIngredients = { load };

	document.querySelectorAll("[data-bundle-ingredients]").forEach((block) => {
		load(block.dataset.sectionId, block.dataset.variantId);
	});
})();
